import { Link } from 'react-router-dom';
import { PublicLayout } from '../components/Layout';

export function NotFound({ reason }: { reason?: 'form' }) {
  return (
    <PublicLayout>
      <div className="flex flex-1 flex-col items-center justify-center px-6 py-20 text-center">
        <p className="text-6xl font-bold text-brand" aria-hidden>
          404
        </p>
        <h1 className="mt-4 text-xl font-semibold">
          {reason === 'form' ? "This form doesn't exist or is no longer available" : "This page doesn't exist"}
        </h1>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-muted">
          {reason === 'form'
            ? 'The link may have been retired or replaced. Please check with the Knocking team member who shared it — they can point you to the current version.'
            : 'The link may be mistyped or the page may have moved.'}
        </p>
        <Link
          to="/"
          className="mt-8 rounded-full bg-brand px-5 py-2.5 text-sm font-semibold text-brand-contrast transition-colors hover:bg-brand-strong"
        >
          Back to Knocking Forms
        </Link>
      </div>
    </PublicLayout>
  );
}
